import React from "react";
import { createTheme, ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { colors } from "./colors";
import { borderRadius, borderRadiusPx } from "./borderRadius";
import { customShadows, muiShadows } from "./shadows";
import { typography, fontFamilies } from "./typography";
import { createComponentOverrides } from "./components";

/**
 * Autobet Centralized Material UI Theme Definition
 */
export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.primary.main,
      light: colors.primary.light,
      dark: colors.primary.dark,
      contrastText: colors.primary.contrastText,
    },
    secondary: {
      main: colors.secondary.main,
      light: colors.secondary.light,
      dark: colors.secondary.dark,
      contrastText: colors.secondary.contrastText,
    },
    error: {
      main: colors.error.main,
      light: colors.error.light,
      dark: colors.error.dark,
      contrastText: colors.error.contrastText,
    },
    warning: {
      main: colors.warning.main,
      light: colors.warning.light,
      dark: colors.warning.dark,
      contrastText: colors.warning.contrastText,
    },
    info: {
      main: colors.info.main,
      light: colors.info.light,
      dark: colors.info.dark,
      contrastText: colors.info.contrastText,
    },
    success: {
      main: colors.success.main,
      light: colors.success.light,
      dark: colors.success.dark,
      contrastText: colors.success.contrastText,
    },
    text: {
      primary: colors.text.primary,
      secondary: colors.text.secondary,
      disabled: colors.text.disabled,
    },
    background: {
      default: colors.background.default,
      paper: colors.background.paper,
    },
    divider: colors.neutral.divider,
    action: colors.action,
  },
  typography,
  shape: {
    borderRadius: borderRadius.default,
  },
  shadows: muiShadows,
  components: createComponentOverrides(),
  // Extended custom tokens directly accessible on the theme object
  custom: {
    colors,
    borderRadius,
    borderRadiusPx,
    shadows: customShadows,
    gradients: colors.gradients,
    overlay: colors.overlay,
    fontFamilies,
  },
});

/**
 * AppThemeProvider Component
 * Wraps your application or components with the centralized MUI Theme & CssBaseline
 */
export const AppThemeProvider = ({ children }) => {
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

// Re-export all tokens for direct access
export {
  colors,
  borderRadius,
  borderRadiusPx,
  customShadows,
  muiShadows,
  typography,
  fontFamilies,
};

// Re-export common lottery constants
export {
  LOTTERY_TYPES,
  STATUS_CONFIG,
  lotteryTypeMapper,
  resultStatusTypeMapper,
  LOTTERY_SORT_OPTIONS,
  lotterySortOptions,
} from "../static/Constants";

export { useTheme } from "@mui/material/styles";
export default theme;
